// Display helpers shared by every dashboard. Pure — no React, no Firestore.

export function fmtTs(ts: unknown): string {
  if (!ts) return "—";
  const obj = ts as { toDate?: () => Date; seconds?: number; _seconds?: number };
  if (typeof obj.toDate === "function") {
    return obj.toDate().toLocaleString();
  }
  if (typeof obj.seconds === "number") {
    return new Date(obj.seconds * 1000).toLocaleString();
  }
  if (typeof obj._seconds === "number") {
    return new Date(obj._seconds * 1000).toLocaleString();
  }
  if (typeof ts === "string" || typeof ts === "number") {
    const d = new Date(ts);
    if (!isNaN(d.getTime())) return d.toLocaleString();
  }
  return "—";
}

export function fmtDate(ts: unknown): string {
  if (!ts) return "—";
  const obj = ts as { toDate?: () => Date; seconds?: number; _seconds?: number };
  if (typeof obj.toDate === "function") {
    return obj.toDate().toLocaleDateString();
  }
  if (typeof obj.seconds === "number") {
    return new Date(obj.seconds * 1000).toLocaleDateString();
  }
  if (typeof obj._seconds === "number") {
    return new Date(obj._seconds * 1000).toLocaleDateString();
  }
  if (typeof ts === "string" || typeof ts === "number") {
    const d = new Date(ts);
    if (!isNaN(d.getTime())) return d.toLocaleDateString();
  }
  return "—";
}

export function fmtBytes(bytes: number | null | undefined): string {
  if (bytes == null) return "—";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let n = bytes;
  let i = 0;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(n >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
}

export function fmtEur(eur: number | null | undefined): string {
  if (eur == null || !Number.isFinite(eur)) return "—";
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(eur);
}

export function fmtNumber(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "—";
  return new Intl.NumberFormat("es-ES").format(n);
}

// UI-only mapping. Backend keeps slugs (`tier-1`, `tier-2`, `enterprise`)
// as the source of truth; this is the single place to rename them for
// users without rewriting Firestore docs.
const TIER_DISPLAY_NAMES: Record<string, string> = {
  "tier-1": "Starter",
  "tier-2": "Pro",
  enterprise: "Enterprise",
};

export function tierDisplayName(
  slug: string | null | undefined,
  fallback?: string | null,
): string {
  if (!slug) return fallback ?? "Sin plan";
  return TIER_DISPLAY_NAMES[slug] ?? fallback ?? slug;
}
